import React, { ReactElement } from 'react';
import { TouchableOpacity } from 'react-native';
import { useSafeArea } from 'react-native-safe-area-context';

import { BackIconSvg } from 'components/Screens/ContentScreens';

type Props = { onPress: () => void };

export const NHSBackButton = ({ onPress }: Props): ReactElement => {
  const safeArea = useSafeArea();
  return (
    <TouchableOpacity
      onPress={onPress}
      accessibilityLabel="Go back"
      style={{
        position: 'absolute',
        top: safeArea.top + 10,
        left: safeArea.left > 0 ? safeArea.left : 16,
        padding: 8,
      }}
    >
      <BackIconSvg />
    </TouchableOpacity>
  );
};
